import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  PageHeader,
  Spin,
  Form,
  Input,
  Row,
  Col,
  Button,
  Popconfirm,
  Table,
  Select,
  InputNumber,
  Space,
  message,
  DatePicker,
} from "antd";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import Page from "_components/Page";
import { Link } from "react-router-dom";
import { companyService, stockIssueService } from "_services";
import { Auth } from "_helpers";
import useFetchCommonTypes from "../../stock-receipts/tiep/Hooks/useCommonTypes";
import { ExportTypes } from "_helpers";
import moment from "moment";
let lineIndex = 0;
function AddWithLines({ history }) {
  const [loading, setLoading] = useState(false);
  const [issuedLines, setIssuedLines] = useState([]);
  const [stores, setStores] = useState([]);
  const [storeAddresses, setStoreAddresses] = useState([]);
  const [customers, setcustomers] = useState([]);
  const [customerAddresses, setcustomerAddresses] = useState([]);
  const [form] = Form.useForm();
  const { Option } = Select;

  const handleFormSubmit = () => {
    const payload = {
      vehicleDetails: {
        deliveryNote: null,
        transactionDate: null,
        inTime: null,
        outTime: null,
        note: null,
        sealNumber: null,
        tellerNumber: null,
        containerNumber: null,
        driverName: null,
        contactNumber: null,
        vehicleNumber: null,
        driverNic: null,
        vehicle: {
          id: "5bef6a42d3920bfa02f0de365f87d517",
        },
      },
      issuedDate: null,
      deliveredDate: null,
      orderStage: "ISSUED",
      store: {
        id: null,
      },
      customer: {
        id: null,
      },
      customReferenceNumber: null,
      issuedLines: null,
      dispatchNumber: null,
      deliveryRemark: null,
      remark: null,
      storeAddress: {
        id: null,
      },
      deliveryAddress: {
        id: null,
      },
      subLocation: {
        id: null,
      },
      stockIssueType: "INDERECT_EXPORT",
    };
    const lines = [...issuedLines];
    console.log(lines);

    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        payload.issuedDate = values.issuedDate;
        payload.customReferenceNumber = values.customReferenceNumber;
        payload.stockIssueType = values.receiptType;
        payload.customer.id = values.customerID;
        payload.store.id = values.storeID;
        payload.deliveryAddress.id = values.customerAddressID;
        payload.storeAddress.id = values.storeAddressID;
        payload.issuedLines = lines.map((issueLine) => ({
          requestLine: null,
          stockType: {
            id: issueLine.stockType.id,
          },
          lotNumber: null,
          quantity: issueLine.quantity,
        }));

        stockIssueService
          .create(payload)
          .then((reponse) => {
            message.success("Successfully Created!");
            setLoading(false);
            history.push(".");
          })
          .catch((error) => {
            setLoading(false);
            message.error(error);
          });
      })
      .catch((error) => {
        setLoading(false);
        message.error(error);
      });
  };

  const { boms: materialTypes, measurementTypes } = useFetchCommonTypes();

  useEffect(() => {
    getStores();
    getCustomers();
  }, []);

  const handleFieldChange = (value, fieldName, key) => {
    const lines = [...issuedLines];
    const newRequestLines = lines.map((line) => {
      const newLine = Object.assign({}, line);
      if (newLine.key === key) {
        if (fieldName === "stockType") {
          newLine[fieldName] = materialTypes.find((item) => item.id === value);
          return newLine;
        } else {
          newLine[fieldName] = value;
          return newLine;
        }
      }
      return newLine;
    });
    //console.log("Lines: ", groupByLines);
    setIssuedLines(newRequestLines);
  };

  const getStoreAddresses = (companyId) => {
    form.resetFields(["storeAddress"]);
    companyService.getById(companyId).then((x) => {
      setStoreAddresses(x.content.addresses);
    });
  };

  const getcustomerAddresses = (companyId) => {
    companyService.getById(companyId).then((x) => {
      setcustomerAddresses(x.content.addresses);
    });
  };

  const getStores = () => {
    companyService.getSuggestion("?companyType=STORE").then((x) => {
      if (x.content.length === 1) {
        form.setFieldsValue({
          store: x.content[0],
        });
        getStoreAddresses(x.content[0].id);
        handleOnChange(x.content[0].name, { key: x.content[0].id }, "storeID");
      }
      setStores(x.content);
    });
  };

  const getCustomers = () => {
    companyService.getSuggestion("?companyType=CUSTOMER").then((x) => {
      if (x.content.length === 1) {
        form.setFieldsValue({
          customer: x.content[0],
        });
        getcustomerAddresses(x.content[0].id);
        handleOnChange(
          x.content[0].name,
          { key: x.content[0].id },
          "customerID"
        );
      }
      setcustomers(x.content);
    });
  };

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "Finished Good",
      dataIndex: "stockType",
      key: "stockTypeCode",
      width: "30%",
      render: (text, record) => {
        return (
          <Form.Item
            //name={["stockType", record.key, "id"]}
            name={`stockType[${record.key}]`}
            key={record.key}
            style={{ marginBottom: "0" }}
            rules={[{ required: true, message: "Required." }]}
            initialValue={text}
            hasFeedback
          >
            <Select
              placeholder="Please select"
              allowClear
              showSearch
              optionFilterProp="children"
              onChange={(e) => handleFieldChange(e, "stockType", record.key)}
            >
              {materialTypes.length > 0 &&
                materialTypes.map((t) => (
                  <Option value={t.id} key={t.id}>
                    {t.code} ({t.name})
                  </Option>
                ))}
            </Select>
          </Form.Item>
        );
      },
    });

    columns.push({
      title: "Quantity",
      key: "quantity",
      align: "Center",
      width: "10%",
      render: (text, record) => {
        return (
          <Form.Item
            name={`quantity[${record.key}]`}
            key={record.key}
            style={{ marginBottom: "0" }}
            rules={[{ required: true, message: "Required." }]}
            hasFeedback
          >
            <InputNumber
              placeholder="Quantity of Items"
              min={record._id ? record.quantity : 0}
              style={{ width: "100%" }}
              onChange={(e) => handleFieldChange(e, "quantity", record.key)}
            />
          </Form.Item>
        );
      },
    });
    columns.push({
      title: "UOM",
      dataIndex: "measurementType",
      key: "measurementType",
      width: "10%",
      render: (text, record) => {
        return (
          <Form.Item
            name={`measurementType[${record.key}]`}
            key={record.key}
            style={{ marginBottom: "0" }}
            rules={[{ required: true, message: "Required." }]}
            initialValue={text}
            hasFeedback
          >
            <Select
              placeholder="Please select"
              allowClear
              showSearch
              optionFilterProp="children"
              onChange={(e) =>
                handleFieldChange(e, "measurementType", record.key)
              }
            >
              {measurementTypes.length > 0 &&
                measurementTypes.map((t) => (
                  <Option value={t.id} key={t.id}>
                    {t.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        );
      },
    });
    columns.push({
      title: "",
      key: "operation",
      width: "5%",
      render: (text, record) => (
        <Space size="small">
          <Button
            type="primary"
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveRequestLine(record);
            }}
            icon={<CloseOutlined />}
            style={{ marginLeft: 5 }}
          ></Button>
          <Button
            type="primary"
            onClick={(e) => {
              e.preventDefault();
              handleSaveRequestLine(e, record.key);
            }}
            style={{ padding: 5, fontSize: 12 }}
          >
            +More
          </Button>
        </Space>
      ),
    });

    return columns;
  };
  const handleAddIssueLines = () => {
    //console.log("Index:", lineIndex);
    const defaultMeasurementType = measurementTypes.find(
      (item) => item.name === "NOS"
    );
    /* const defaultPackingType = packingTypes.find(
      (item) => item.name === "PALLET"
    ); */

    const newLine =
      defaultMeasurementType === null
        ? { requestedItems: [] }
        : {
            requestedItems: [],
            measurementType: defaultMeasurementType.id,
          };
    newLine.key = lineIndex;
    /* if (defaultPackingType) {
      newLine.packingType = defaultPackingType;
    } */
    // const lines = [...issuedLines, newLine];
    //console.log("Lines:", lines);
    setIssuedLines((prevLines) => [...prevLines, newLine]);
    lineIndex += 1;
  };
  const getActionButtons = () => {
    let buttons = [];

    const onCancel = () => {
      history.push(".");
    };

    buttons.push(
      <Popconfirm
        title="Are you sure to issue these stocks?"
        onConfirm={(e) => {
          e.preventDefault();
          handleFormSubmit();
        }}
        key="save-confirm"
      >
        <Button
          key="btn-save"
          type="primary"
          htmlType="submit"
          loading={loading}
        >
          Save
        </Button>
      </Popconfirm>
    );

    buttons.push(
      <Button key="btn-cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );

    return buttons;
  };

  const handleRemoveRequestLine = (line) => {
    const lines = [...issuedLines];
    if (lines.includes(line)) {
      lines.splice(lines.indexOf(line), 1);
      setIssuedLines(lines);
    }
  };
  const getRowBykey = (key, newData) => {
    return (issuedLines || newData).filter((item) => item.key === key)[0];
  };

  const handleSaveRequestLine = (e, key) => {
    e.persist();

    const target = getRowBykey(key) || {};

    console.log("target", target);

    if (!target.stockType || !target.quantity || !target.measurementType) {
      message.error("Please complete the requested line details.");
      e.target.focus();
      return;
    }
    handleAddIssueLines();
  };

  const handleOnChange = (selected, option, idField) => {
    form.setFieldValue(idField, option.key);
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>{" "}
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {" "}
            <Link to="/stock-issue">Stock Issue</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {" "}
            <Link to="/Add">Add</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      extra={getActionButtons()}
    >
      <Page inner>
        <Spin tip="Loading..." spinning={loading}>
          <Form
            layout="vertical"
            form={form}
            onFinish={handleFormSubmit}
            initialValues={{ receiptType: "INDERECT_EXPORT" }}
          >
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name={["customer"]}
                  rules={[
                    { required: true, message: "There should be a Customer" },
                  ]}
                  label="Customer"
                >
                  <Select
                    placeholder="Please select"
                    showSearch
                    optionFilterProp="children"
                    onChange={(selected, option) => {
                      getcustomerAddresses(option.key);
                      handleOnChange(selected, option, "customerID");
                    }}
                    allowClear
                  >
                    {customers.length > 0 &&
                      customers.map((t) => (
                        <Option value={t.name} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={["store"]}
                  rules={[{ required: true }]}
                  label="Store"
                >
                  <Select
                    placeholder="Please select"
                    showSearch
                    optionFilterProp="children"
                    onChange={(selected, option) => {
                      getStoreAddresses(option.key);
                      handleOnChange(selected, option, "storeID");
                    }}
                    allowClear
                  >
                    {stores.length > 0 &&
                      stores.map((t) => (
                        <Option value={t.name} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={["driverName"]}
                  rules={[{ required: true }]}
                  label="Driver Name"
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={["driverContact"]}
                  rules={[{ required: true }]}
                  label="Driver Phone Number"
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name={["customerAddress"]}
                  rules={[{ required: true }]}
                  label="Customer Address"
                >
                  <Select
                    placeholder="Please select"
                    onChange={(selected, option) =>
                      handleOnChange(selected, option, "customerAddressID")
                    }
                    allowClear
                  >
                    {customerAddresses.length > 0 &&
                      customerAddresses.map((t) => (
                        <Option value={t.name || t.code || t.id} key={t.id}>
                          {t.address || t.code || t.city || t.id}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={["storeAddress"]}
                  rules={[
                    {
                      required: true,
                      message: "There should be a Store Address",
                    },
                  ]}
                  label="Store Address"
                >
                  <Select
                    placeholder="Please select"
                    onChange={(selected, option) =>
                      handleOnChange(selected, option, "storeAddressID")
                    }
                    allowClear
                  >
                    {storeAddresses.length > 0 &&
                      storeAddresses.map((t) => (
                        <Option value={t.name || t.code || t.id} key={t.id}>
                          {t.address || t.code || t.city || t.id}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={["vehicleNumber"]}
                  rules={[{ required: true }]}
                  label="Vehicle Number"
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={["trailerNumber"]}
                  rules={[{ required: true }]}
                  label="Trailer Number"
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name={["customReferenceNumber"]}
                  rules={[{ required: true }]}
                  label="Cus.Dec.No#"
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="receiptType" label="Issue Type">
                  <Select
                    showSearch
                    allowClear
                    showArrow={false}
                    optionFilterProp="children"
                    placeholder="Export Type"
                  >
                    {ExportTypes.map((t, index) => (
                      <Select.Option value={t.value} key={t.value}>
                        {t.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={["issuedDate"]}
                  rules={[{ required: true }]}
                  label="Issued Date"
                >
                  <DatePicker />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item name="storeID" hidden>
                  <Input></Input>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name="customerID" hidden>
                  <Input></Input>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="storeAddressID" hidden>
                  <Input></Input>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="customerAddressID" hidden>
                  <Input></Input>
                </Form.Item>
              </Col>
            </Row>

            {issuedLines == 0 && (
              <Button
                style={{
                  width: "100%",
                  marginTop: 16,
                  marginBottom: 8,
                  color: "white",
                  backgroundColor: "#177ddc",
                }}
                type="dashed"
                onClick={handleAddIssueLines}
                icon={<PlusOutlined />}
              >
                Add Item
              </Button>
            )}

            {issuedLines?.length > 0 && (
              <Table
                dataSource={issuedLines}
                columns={getLineColumns()}
              ></Table>
            )}
          </Form>
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default AddWithLines;
